import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import CustomButton from '../customButton';
import { makeStyles } from '@mui/styles';

// Define custom styles
const useStyles = makeStyles((theme) => ({
    customDialog: {
        height: '400px',
        width: '100%'
    }
}));

const ConfirmationModal = ({
    open, content, onClose, onConfirm, title, primaryButtonText, isCancelShow=true, customClass=false,hideConfirmButton = false 
}) => {
    const classes = useStyles();

    return (
        <Dialog
            classes={{ paper: customClass ? classes.customDialog : '' }}
            open={open}
            onClose={onClose}
        >
            <DialogTitle>{title}</DialogTitle>
            <Divider />
            <DialogContent>
                {content}
            </DialogContent>
            <Divider />
            <DialogActions>
                {isCancelShow ? (
                    <CustomButton
                        handleClick={onClose}
                        title="Cancel"
                    />
                ) : null}
                {
                    !hideConfirmButton ? <CustomButton
                        buttonColor="#AD509E"
                        handleClick={onConfirm}
                        title={primaryButtonText}
                        titleColor="#FFFFFF"
                    /> : null
                }
                
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
